var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm.isRouterAlive ? [_c('layout'), [_c('pop-how-works', {
    attrs: {
      "show": _vm.popHowWorksShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popHowWorksShow = $event;
      }
    }
  })]] : _vm._e(), _c('p-footer')], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };